export const SECRET_PASS = process.env.REACT_APP_SECRET